interface ProgressProps {
  value: number;
  colorScheme?: string;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

export function Progress({ value, colorScheme = 'blue', size = 'md', className }: ProgressProps) {
  const height = size === 'sm' ? 'h-1.5' : size === 'lg' ? 'h-4' : 'h-2.5';

  const colorMap: Record<string, string> = {
    blue: 'bg-action-primary',
    green: 'bg-feedback-success',
    red: 'bg-feedback-error',
    yellow: 'bg-feedback-warning',
    orange: 'bg-state-running',
  };

  const barColor = colorMap[colorScheme] ?? 'bg-action-primary';

  return (
    <div className={`w-full bg-bg-subtle rounded-full overflow-hidden ${height} ${className ?? ''}`}>
      <div
        className={`${barColor} ${height} rounded-full transition-[width] duration-300`}
        style={{ width: `${Math.min(100, Math.max(0, value))}%` }}
      />
    </div>
  );
}
